import React, { useState } from "react";
import Button from "../../components/ui/Button";
import { useNavigate } from "react-router-dom";
import Icon from "../../components/AppIcon";

const ContactSupport = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background py-12 pb-12 px-4 pt-32 lg:pt-36">
      <div className="max-w-xl w-full bg-surface border border-border rounded-xl shadow-elevation-1 p-8">
        {submitted ? (
          <div className="text-center text-success mb-6 flex flex-col items-center">
            <Icon name="CheckCircle" size={32} className="mb-2" />
            <p className="font-medium">Thank you for contacting support!</p>
            <p className="text-sm text-text-secondary">
              We'll respond to your inquiry as soon as possible.
            </p>
          </div>
        ) : (
          <>
            <div className="flex flex-col items-center mb-6">
              <Icon
                name="MessageCircle"
                size={40}
                className="text-primary mb-2"
              />
              <h1 className="text-2xl font-bold mb-2 text-text-primary">
                Contact Support
              </h1>
              <p className="text-text-secondary text-center mb-4">
                Need help? Fill out the form below and our team will get back to
                you soon.
              </p>
            </div>
            <form onSubmit={handleSubmit} className="space-y-4 mb-5">
              <div>
                <label className="block text-sm font-medium text-text-primary mb-1">
                  Name
                </label>
                <input
                  type="text"
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  className="w-full border border-border rounded-lg px-3 py-2 bg-background text-text-primary"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-text-primary mb-1">
                  Email
                </label>
                <input
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  className="w-full border border-border rounded-lg px-3 py-2 bg-background text-text-primary"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-text-primary mb-1">
                  Message
                </label>
                <textarea
                  name="message"
                  value={form.message}
                  onChange={handleChange}
                  className="w-full border border-border rounded-lg px-3 py-2 bg-background text-text-primary"
                  rows={4}
                  required
                />
              </div>
              <Button
                variant="primary"
                size="md"
                type="submit"
                iconName="Send"
                iconSize={18}
                className="w-full"
              >
                Send Message
              </Button>
            </form>
          </>
        )}
        <Button
          fullWidth
          variant="outline"
          size="md"
          iconName="ArrowLeft"
          iconSize={18}
          onClick={() => navigate(-1)}
        >
          Back to Account Connection
        </Button>
      </div>
    </div>
  );
};

export default ContactSupport;
